<template>
  <div class="d-inline-flex align-center">
    <v-menu offset-y :close-on-content-click="false" v-model="menu">
      <v-btn slot="activator" outline color="primary" :loading="loading">
        <v-icon left>mdi-filter-variant</v-icon>
        {{ $t('Filtros guardados') }}
      </v-btn>
      <v-card>
        <v-list dense>
          <v-list-tile v-if="!savedFilters.length">
            <v-list-tile-title>{{ $t('No tienes filtros guardados') }}</v-list-tile-title>
          </v-list-tile>
          <v-list-tile v-for="item in savedFilters" :key="item.id" @click="apply(item)">
            <v-list-tile-title>{{ item.name }}</v-list-tile-title>
            <v-list-tile-action>
              <v-btn icon small :title="$t('Eliminar')" @click.stop="remove(item)">
                <v-icon small>mdi-delete</v-icon>
              </v-btn>
            </v-list-tile-action>
          </v-list-tile>
        </v-list>
        <v-divider></v-divider>
        <v-layout align-center class="pa-2">
          <v-text-field
            v-model="newName"
            :label="$t('Nombre del filtro')"
            maxlength="100"
            hide-details
            single-line
            @keyup.enter="save"
          ></v-text-field>
          <v-btn icon color="primary" :disabled="!newName.trim()" :title="$t('Guardar')" @click="save">
            <v-icon>mdi-content-save</v-icon>
          </v-btn>
        </v-layout>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import apiCtrl from '@/services/api/abstract/abstract-api.js';

/**
 * Filtros guardados por usuario para una tabla de control. `scope` identifica la tabla y
 * `current` es el estado de filtros que se guarda tal cual; al elegir uno se emite `apply`
 * con ese mismo estado para que la tabla lo restaure. Si ya existe un filtro con el mismo
 * nombre se sobrescribe.
 */
export default {
  name: 'OgSavedFilters',
  props: {
    scope: { type: String, required: true },
    current: { type: Object, required: true },
  },
  data() {
    return {
      menu: false,
      loading: false,
      savedFilters: [],
      newName: '',
    };
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      this.loading = true;
      return apiCtrl
        .get('/user-saved-filters', { params: { scope: this.scope } })
        .then(res => {
          this.savedFilters = res.data;
        })
        .catch(() => {
          this.$emit('error', this.$t('No se pudieron cargar los filtros guardados'));
        })
        .finally(() => {
          this.loading = false;
        });
    },
    save() {
      const name = this.newName.trim();
      if (!name) {
        return;
      }
      apiCtrl
        .post('/user-saved-filters', {
          scope: this.scope,
          name,
          filters: JSON.parse(JSON.stringify(this.current)),
        })
        .then(() => {
          this.newName = '';
          this.$emit('saved', this.$t('Filtro guardado'));
          return this.load();
        })
        .catch(() => {
          this.$emit('error', this.$t('No se pudo guardar el filtro'));
        });
    },
    apply(item) {
      this.menu = false;
      this.$emit('apply', JSON.parse(JSON.stringify(item.filters)));
    },
    remove(item) {
      apiCtrl
        .delete('/user-saved-filters/' + item.id)
        .then(() => this.load())
        .catch(() => {
          this.$emit('error', this.$t('No se pudo eliminar el filtro'));
        });
    },
  },
};
</script>
